import PptxGenJS from "pptxgenjs";
import dayjs from "dayjs";
import { TemplateData } from "../index"; // Import types from the main template definition

export const addTitleSlide = (pres: PptxGenJS, data: TemplateData) => {
  const slide = pres.addSlide({ masterName: "TITLE_MASTER" });

  if (data.title) {
    slide.addText(data.title, { placeholder: "title" });
  }

  if (data.candidateName) {
    slide.addText(data.candidateName, { placeholder: "candidate-name" });
  }

  if (data.candidatePositionRole) {
    slide.addText(data.candidatePositionRole, {
      placeholder: "candidate-position-role",
    });
  }

  slide.addText(dayjs().format("MMMM YYYY"), { placeholder: "date" });
};
